"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoClosedIcon = createIcon({
  displayName: "CompRegoClosedIcon",
  viewBox: "0 0 45 32",
  path: (
    <>
      <path
        d="M33.55,18l-2.86-2.8,4.24-4.2-4.24-4.15,2.86-2.85,4.3,4.2,4.24-4.2,2.91,2.85-4.3,4.15,4.3,4.2-2.91,2.8-4.24-4.15-4.3,4.15ZM16.36,16c-2.25,0-4.18-.78-5.78-2.35-1.6-1.57-2.4-3.45-2.4-5.65s.8-4.08,2.4-5.65c1.6-1.57,3.53-2.35,5.78-2.35s4.18.78,5.78,2.35c1.6,1.57,2.4,3.45,2.4,5.65s-.8,4.08-2.4,5.65c-1.6,1.57-3.53,2.35-5.78,2.35ZM0,32v-5.6c0-1.13.3-2.17.89-3.12.6-.95,1.39-1.67,2.38-2.17,2.11-1.03,4.26-1.81,6.44-2.33,2.18-.52,4.4-.77,6.65-.77s4.47.26,6.65.77c2.18.52,4.33,1.29,6.44,2.33.99.5,1.78,1.23,2.38,2.17.6.95.89,1.99.89,3.12v5.6H0ZM4.09,28h24.55v-1.6c0-.37-.09-.7-.28-1-.19-.3-.43-.53-.74-.7-1.84-.9-3.7-1.58-5.57-2.03-1.88-.45-3.77-.67-5.68-.67s-3.8.23-5.68.67c-1.88.45-3.73,1.12-5.57,2.03-.31.17-.55.4-.74.7-.19.3-.28.63-.28,1v1.6ZM16.36,12c1.12,0,2.09-.39,2.89-1.18.8-.78,1.2-1.72,1.2-2.82s-.4-2.04-1.2-2.82c-.8-.78-1.76-1.18-2.89-1.18s-2.09.39-2.89,1.18c-.8.78-1.2,1.72-1.2,2.82s.4,2.04,1.2,2.82c.8.78,1.76,1.18,2.89,1.18Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default CompRegoClosedIcon;
